import { AiFillLock } from 'react-icons/ai';

import { type FieldComponent } from '@core/blocks/edu-flow-2/utils/fieldTypeDictionary';

import styles from './SecurityDisclaimerField.module.css';

const SecurityDisclaimerField: FieldComponent = ({ field: { content } }) => {
  if (!content) return <></>;

  return (
    <div data-testid="security-disclaimer-field" className={styles.disclaimer}>
      <AiFillLock className={styles.icon} />
      <p dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default SecurityDisclaimerField;
